import styled from 'styled-components';

export const NewMembersListContainer = styled.div`
    width: 100%;
    padding: 0 1em;
    box-sizing: border-box;
`;